module.exports = __webpack_public_path__ + "static/media/recommendation_Icon.5da0065b.svg";